import { UrlConstants } from "../url.constants";
export class ApiBuildingPlansInspectorateConstants {
    static URL = UrlConstants.API_V2 + "BuildingPlansInspectorate";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetBuildingPlansInspectorateApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateBuildingPlansInspectorateInvoiceReport";
    static FUNCTION_SET_PROPERTIES = "SetBuildingPlansInspectorateProperties";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetBuildingPlansInspectorateRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_VERIFY_BPI_BPAMS_REFERENCE_NUMBER = "VerifyBpiBpamsReferenceNumber";
    static FUNCTION_GET_LINK_BP_APPLICATION = "GetLinkBpApplications";
    static FUNCTION_LINK_BP_APPLICATION = "LinkBpApplications";
    static FUNCTION_DELINK_BP_APPLICATION = "DelinkBpApplications";
    static FUNCTION_APPLICATION_TYPES = "GetBpiApplicationTypes";
}
